<script>
import { Line, mixins } from 'vue-chartjs';
import chartMixins from '../../../mixins/charts';

const { reactiveProp } = mixins;

export default Line.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    this.addPlugin(chartMixins.plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  },
});
</script>



// WEBPACK FOOTER //
// AnalyticsAreaChart.vue?4f56019a